<template>
  <div>
    <!-- 问题登记列表 -->
    <baseBreadcrumb :page="$t('message.aftersaleIssueCreate')" :menu="$t('message.operationAndMaintenance')" />
    <div class="body">
      <div class="tabs">
        <el-tabs v-model="datas.status" type="card" @tab-click="search">
          <el-tab-pane v-for="(item, index) in tabs" :label="`${item.label}(${item.count})`" :name="item.status + ''"
            :key="index">
          </el-tab-pane>
        </el-tabs>
        <div class="add" @click="add">
          <!-- 售后问题登记 -->
          <el-button type="success">售后问题登记</el-button>
        </div>

      </div>
      <!-- 搜索 -->
      <div class="search">
        <!-- 客户ID/客户名称 -->
        <div class="item">
          <el-input v-model="datas.customer_keyword" placeholder="请输入客户ID/客户名称" clearable></el-input>
        </div>
        <!-- 问题分类筛选 -->
        <div class="item">
          <el-select v-model="datas.problem_category" placeholder="请选择问题分类">
            <el-option v-for="(item, index) in problemCategoy" :label="item.label" :value="item.value"
              :key="index"></el-option>
          </el-select>
        </div>
        <!-- 配送单号 -->
        <div class="item">
          <el-input v-model="datas.porder_sn" placeholder="请输入配送单号" clearable></el-input>
        </div>
        <!-- 订单号 -->
        <div class="item">
          <el-input v-model="datas.order_no" placeholder="请输入订单号" clearable></el-input>
        </div>
        <!-- 售后单号 -->
        <div class="item">
          <el-input v-model="datas.after_sale_sn" placeholder="请输入售后单号" clearable></el-input>
        </div>
        <!-- 赔款单号 -->
        <div class="item">
          <el-input v-model="datas.reparation_sn" placeholder="请输入赔款单号" clearable></el-input>
        </div>
        <!-- 登记人 -->
        <div class="item">
          <el-input v-model="datas.created_by_admin" placeholder="请输入登记人" clearable></el-input>
        </div>
        <!-- 责任人 -->
        <div class="item">
          <el-input v-model="datas.responsible_keyword" placeholder="请输入责任人" clearable></el-input>
        </div>
        <!-- 登记时间 -->
        <div class="time">
          <el-date-picker v-model="time" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
        </div>
        <div class="item">
          <el-button type="primary" @click="search">搜索</el-button>
          <el-button @click="reset">重置</el-button>
        </div>
      </div>
      <!-- 列表 -->
      <div class="table">
        <ol :style="{ width: datas.status == 1 ? '100%' : '2500px' }">
          <!-- 基础信息 -->
          <li style="flex:0 200px"> {{ $t('message.basicInformation') }}</li>
          <!-- 客户信息 -->
          <li> {{ $t('message.userInfo') }}</li>
          <!-- 配送单号 -->
          <li> {{ $t('message.porderNumber') }}</li>
          <!-- 订单号 -->
          <li> {{ $t('message.orderNumber') }}</li>
          <!-- 不良数 -->
          <li class="flex05"> {{ $t('message.adverseNumber') }}</li>
          <!-- 不良合计金额（元） -->
          <li> {{ $t('message.badNumberTotalAmount') }}</li>
          <!-- 售后问题说明 -->
          <li> {{ $t('message.afterSaleProblemDescription') }}</li>
          <!-- 问题图片 -->
          <li> {{ $t('message.problemPic') }}</li>
          <!-- 确认明细 -->
          <li> {{ $t('message.confirmDetail') }}</li>
          <!-- 业务初步处理 -->
          <li v-if="datas.status >= '2' || datas.status == 'all'"> {{ $t('message.businessInitialProcessing') }}</li>
          <!-- 课长决策 -->
          <li v-if="datas.status >= '3' || datas.status == 'all'"> {{ $t('message.classLeaderDecision') }}</li>
          <!-- 业务最终处理 -->
          <li v-if="datas.status >= '4' || datas.status == 'all'"> {{ $t('message.businessFinalProcessing') }}</li>
          <!-- 问题分类 -->
          <li v-if="datas.status >= '2' || datas.status == 'all'"> {{ $t('message.problemClassification') }}</li>
          <!-- 关联售后单 -->
          <li v-if="datas.status >= '5' || datas.status == 'all'"> {{ $t('message.relatedAfterSaleOrder') }}</li>
          <!-- 关联赔款单 -->
          <li v-if="datas.status >= '5' || datas.status == 'all'"> {{ $t('message.relatedCompensationOrder') }}</li>
          <!-- 操作 -->
          <li class="operation" v-if="datas.status < '5' || datas.status == 'all'"> {{ $t('message.operation') }}</li>
        </ol>
        <ul v-for="(item, index) in tableData" :key="index" :style="{ width: datas.status == 1 ? '100%' : '2500px' }">
          <!-- 基础信息 -->
          <li style="flex:0 200px">
            <div class="template">
              <p>登记人: {{ item.created_by_admin ? item.created_by_admin.realname : '' }}</p>
              <p>登记来源: {{ item.source_type_text }}</p>
              <p>登记时间: {{ item.created_at }}</p>
              <p>确认时间: {{ item.confirm_at }}</p>
              <p>初步处理: {{ item.biz_at }}</p>
              <p>课长决策: {{ item.leader_at }}</p>
              <p>最终完成: {{ item.final_at }}</p>
            </div>
          </li>
          <!-- 客户信息 -->
          <li>
            <div class="template">
              <p>客户ID: {{ item.user.id }}</p>
              <p>客户名称: {{ item.user.realname }}</p>
              <p>
                <attributeName :name="item.user.attribute_name" />
              </p>
            </div>
          </li>
          <!-- 配送单号 -->
          <li>
            <router-link :to="'/porderDetail?porder_sn=' + item.porder_sn" class="a-link" target="_blank">
              {{ item.porder_sn }}
            </router-link>
          </li>
          <!-- 订单号 -->
          <li>
            <div class="template" v-if="item.order_detail != false">
              <p v-for="(order, index) in item.order_detail" :key="index">
                <router-link :to="'/orderPaymentDetail?order_sn=' + item.order_sn" class="a-link" target="_blank">
                  {{ item.order_sn }} - {{ order.sorting }}
                </router-link>
              </p>
            </div>
            <div class="template" v-if="item.porder_detail != false">
              <p v-for="(order, index) in item.porder_detail" :key="index">
                <router-link :to="'/orderPaymentDetail?order_sn=' + item.order_sn" class="a-link" target="_blank">
                  {{ order.order_sn }} - {{ order.sorting }}
                </router-link>
              </p>
            </div>
          </li>
          <!-- 不良数 -->
          <li class="flex05"> {{ item.problem_num }}</li>
          <!-- 不良合计金额（元） -->
          <li> {{ item.problem_amount }}</li>
          <!-- 售后问题说明 -->
          <li>
            <div class="temlplate" style="width: 100%;">
              <div class="chat_type" v-if="item.chat_type">
                <div class="img">
                  <img
                    :src="item.chat_type == '1' ? require('@/assets/icon/Rakuchat.png') : require('@/assets/icon/chatword.png')"
                    alt=""> {{ item.chat_type == '1' ? 'rakuchat' : 'chatword' }}
                </div>
                <!-- 是否投诉 -->
                <el-button :type="item.is_complaint == '1' ? 'danger' : 'success'" size="mini">{{ item.is_complaint ==
                  '1' ? '确认为投诉' : '非投诉' }}</el-button>
              </div>
              <div>
                {{ item.problem_desc }}
              </div>
            </div>
          </li>
          <!-- 问题图片 -->
          <li>
            <div class="template">
              <el-image v-for="(img, index) in item.problem_images" :key="index" :src="img" alt=""
                style="width: 60px; height: 60px; margin-right: 10px;" :preview-src-list="[img]">
              </el-image>
            </div>
          </li>
          <!-- 确认明细 -->
          <li>
            <el-input v-model="item.confirm_result" placeholder="请输入确认结果" type="textarea" :disabled="item.status != '1'"
              @blur="aftersaleIssueUpdateConfirmResult(item)"></el-input>
          </li>
          <!-- 业务初步处理 -->
          <li v-if="datas.status >= '2' || datas.status == 'all'">
            <div class="template">
              <el-image v-for="(img, index) in item.biz_images" :key="index" :src="img" alt=""
                style="width: 60px; height: 60px; margin-right: 10px;margin-bottom: 10px;" :preview-src-list="[img]">
              </el-image>
              <p>
                <el-input v-model="item.biz_solution" placeholder="请输入业务初步处理" type="textarea"
                  :disabled="item.status != '2'" @blur="updateBizSolution(item)"></el-input>
              </p>
            </div>
          </li>
          <!-- 课长决策 -->
          <li v-if="datas.status >= '3' || datas.status == 'all'">
            <el-input v-model="item.leader_solution" placeholder="请输入课长决策" type="textarea"
              :disabled="item.status != '3'" @blur="updateLeaderSolution(item)"></el-input>
          </li>
          <!-- 业务最终处理 -->
          <li v-if="datas.status >= '4' || datas.status == 'all'">
            <div class="template">
              <el-image v-for="(img, index) in item.final_images" :key="index" :src="img" alt=""
                style="width: 60px; height: 60px;  margin-right: 10px;margin-bottom: 10px;" :preview-src-list="[img]">
              </el-image>
              <p>
                <el-input v-model="item.final_solution" placeholder="请输入业务最终处理" type="textarea"
                  :disabled="item.status != '4'" @blur="updateFinalSolution(item)"></el-input>
              </p>
            </div>
          </li>
          <!-- 问题分类 -->
          <li v-if="datas.status >= '2' || datas.status == 'all'"> {{ item.problem_category }}</li>
          <!-- 关联售后单 -->
          <li v-if="datas.status >= '5' || datas.status == 'all'">
            <div class="template">
              <p style="margin-top: 10px;" v-for="after_sale_sn in item.after_sale_sn">
                <router-link :to="'/afterSale?after_sale_sn=' + after_sale_sn" class="a-link" target="_blank">
                  {{ after_sale_sn }}
                </router-link>
              </p>
            </div>
          </li>
          <!-- 关联赔款单 -->
          <li v-if="datas.status >= '5' || datas.status == 'all'">
            <div class="template">
              <div style="margin-bottom: 10px;" v-for="reparation in item.responsible_info_arr">
                <router-link :to="'/reparationList?reparation_sn=' + reparation.reparation_sn" class="a-link"
                  target="_blank">
                  {{ reparation.reparation_sn }}
                </router-link>
                <p v-for="(amount, amountIndex) in reparation.reparation_amount" :key="amountIndex">{{
                  amount.type_label }} : {{ amount.responsible_name }} : {{ amount.amount }}</p>
              </div>

            </div>
          </li>
          <!-- 操作 -->
          <li class="operation" v-if="datas.status < '5' || datas.status == 'all'">
            <div class="btn" v-if="item.status == '1'">
              <p style="margin-bottom: 10px;">
                <el-button type="primary" size="mini" @click="confirm(item)">确认</el-button>
              </p>
              <!-- 取消登记 -->
              <p>
                <el-button type="danger" size="mini" @click="cancel(item)" class="dark">取消登记</el-button>
              </p>
            </div>
            <div class="btn" v-if="item.status == '2'">
              <p style="margin-bottom: 10px;">
                <el-button type="primary" size="mini" @click="preliminaryBusinessHandling(item)">业务初步处理</el-button>
              </p>
              <!-- 取消登记 -->
              <p>
                <el-button type="danger" size="mini" @click="cancel(item)" class="dark">取消登记</el-button>
              </p>
            </div>
            <div class="btn" v-if="item.status == '3'">
              <p style="margin-bottom: 10px;">
                <el-button type="primary" size="mini" @click="sectionChiefDecision(item)">决策</el-button>
              </p>

            </div>
            <div class="btn" v-if="item.status == '4'">
              <p style="margin-bottom: 10px;">
                <el-button type="primary" size="mini" @click="finalDecision(item)">业务最终处理</el-button>
              </p>

            </div>
          </li>
        </ul>
      </div>
      <!-- 分页 -->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
          :page-sizes="[10, 20, 50, 100]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 问题登记 -->
    <issueCreate ref="issueCreate" />
    <!-- 取消登记 -->
    <el-dialog title="取消登记" :visible.sync="dialogVisible" width="450px">
      <p style="margin-bottom: 20px; color: #B4272D;">请谨慎取消，取消后无法进行回退，确认取消请填写取消原因</p>
      <el-input v-model="itemData.cancel_reason" placeholder="请输入取消原因" type="textarea"></el-input>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="cancelRegistration">确认</el-button>
      </div>
    </el-dialog>
    <!--问题确定 -->
    <issueConfirm ref="issueConfirm" :problemCategoy="problemCategoy" />
    <!-- 业务初步处理 -->
    <preliminaryBusinessHandling ref="preliminaryBusinessHandling" />
    <!-- 课长决策 -->
    <sectionChiefDecision ref="sectionChiefDecision" :problemCategoy="problemCategoy" />
    <!-- 业务最终处理 -->
    <finalDecision ref="finalDecision" :problemCategoy="problemCategoy" />
  </div>
</template>
<script>
import issueCreate from './components/issueCreate.vue'
import issueConfirm from './components/issueConfirm.vue'
import preliminaryBusinessHandling from './components/preliminaryBusinessHandling.vue'
import sectionChiefDecision from './components/sectionChiefDecision.vue'
import finalDecision from './components/finalDecision.vue'
export default {
  components: {
    issueCreate,
    issueConfirm,
    preliminaryBusinessHandling,
    sectionChiefDecision,
    finalDecision
  },
  data() {
    return {
      tableData: [],
      tabs: [],
      issueTypes: [],
      time: [],
      datas: {
        status: '1',
        customer_keyword: '',
        problem_category: '',
        porder_sn: '',
        order_no: '',
        after_sale_sn: '',
        reparation_sn: '',
        created_by_admin: '',
        responsible_keyword: '',
        created_start: '',
        created_end: '',
        page: 1,
        pageSize: 10
      },
      total: 0,
      dialogVisible: false,
      itemData: {
        id: '',
        cancel_reason: ''
      },
      problemCategoy: []//售后问题分类
    };
  },
  created() {
    this.$api.siteConfiguration.aftersaleIssueStatusEnum().then(res => {
      this.issueTypes = res.data
    })
    // 售后问题分类枚举
    this.$api.siteConfiguration.aftersaleIssueProblemCategoryEnum().then(res => {
      this.problemCategoy = res.data
    })
    this.aftersaleIssueStatusStatistics()
    this.aftersaleIssueList()

  },
  methods: {
    // 问题登记状态统计
    aftersaleIssueStatusStatistics() {
      this.$api.siteConfiguration.aftersaleIssueStatusStatistics().then(res => {
        this.tabs = res.data
      })
    },
    // 问题登记列表
    aftersaleIssueList() {
      if (this.time.length == 2) {
        this.datas.created_start = this.time[0]
        this.datas.created_end = this.time[1]
      }
      this.$api.siteConfiguration.aftersaleIssueList(this.datas).then(res => {
        res.data.data.forEach(item => {
          item.responsible_info = item.responsible_info.replace(/\n/g, '<br>')
        })
        this.tableData = res.data.data
        this.total = res.data.total
      })
    },
    // 搜索
    search() {
      this.datas.page = 1
      this.aftersaleIssueList()
      this.aftersaleIssueStatusStatistics()
    },
    // 重置
    reset() {
      this.datas = {
        status: this.datas.status,
        customer_keyword: '',
        problem_category: '',
        porder_sn: '',
        order_no: '',
        after_sale_sn: '',
        reparation_sn: '',
        created_by_admin: '',
        responsible_keyword: '',
        created_start: '',
        created_end: '',
        page: 1,
        pageSize: 10
      }
      this.time = []
      this.search()
    },
    // 分页
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.aftersaleIssueList();
    },
    // 一页条数
    handleCurrentChange(val) {
      this.datas.page = val;
      this.aftersaleIssueList();
    },
    // 新增问题登记
    add() {
      this.$refs.issueCreate.form = {
        client_id: '',
        problem_images: [],
        problem_desc: '',
        problem_category: '',
        product_id: '',
        order_id: '',
        problem_num: '',
        problem_amount: '',
        porder_sn: '',
        order_sn: '',
        porder_detail: [],
        order_detail: []
      }

      this.$refs.issueCreate.radio = 1
      this.$refs.issueCreate.dialogVisible = true
    },
    // 确认登记
    confirm(item) {
      this.$refs.issueConfirm.form = {
        problem_category: item.problem_category,
        product_id: item.product_id,
        order_id: item.order_id,
        problem_num: item.problem_num,
        problem_amount: item.problem_amount,
        porder_sn: item.porder_sn,
        order_sn: item.order_sn,
        porder_detail: item.porder_detail,
        order_detail: item.order_detail,
        id: item.id,
        confirm_result: item.confirm_result,
        is_problem: 1,
        is_complaint: 1,
      }
      this.$refs.issueConfirm.radio = item.porder_sn ? 1 : 2
      this.$refs.issueConfirm.chat_type = item.chat_type
      this.$refs.issueConfirm.dialogVisible = true
    },
    // 取消登记
    cancel(item) {
      this.itemData.id = item.id
      this.itemData.cancel_reason = item.cancel_reason
      this.dialogVisible = true
    },
    // 确认取消登记
    cancelRegistration() {
      if (!this.itemData.cancel_reason) {
        this.$message.error('请输入取消原因');
        return;
      }
      this.$api.siteConfiguration.aftersaleIssueCancel(this.itemData).then(res => {
        this.$message.success(res.msg);
        this.dialogVisible = false
        this.aftersaleIssueList()
        this.aftersaleIssueStatusStatistics()
      })
    },
    // 确认处理结果
    aftersaleIssueUpdateConfirmResult(item) {
      let datas = {
        id: item.id,
        confirm_result: item.confirm_result
      }
      this.$api.siteConfiguration.aftersaleIssueUpdateConfirmResult(datas).then(res => {
        this.$message.success(res.msg);
      })
    },
    // 业务初步处理
    preliminaryBusinessHandling(item) {
      this.$refs.preliminaryBusinessHandling.form = {
        id: item.id,
        biz_images: [],
        biz_solution: item.biz_solution,
      }
      this.$refs.preliminaryBusinessHandling.dialogVisible = true
    },
    // 更新业务初步处理
    updateBizSolution(item) {
      let datas = {
        id: item.id,
        biz_solution: item.biz_solution
      }
      this.$api.siteConfiguration.updateBizSolution(datas).then(res => {
        this.$message.success(res.msg);
      })
    },
    // 课长决策
    sectionChiefDecision(item) {
      this.$refs.sectionChiefDecision.form = {
        id: item.id,
        is_complaint: item.is_complaint,
        problem_category: item.problem_category,
        leader_solution: item.leader_solution,
      }
      this.$refs.sectionChiefDecision.dialogVisible = true
    },
    // 更新课长决策
    updateLeaderSolution(item) {
      let datas = {
        id: item.id,
        leader_solution: item.leader_solution,
      }
      this.$api.siteConfiguration.updateLeaderSolution(datas).then(res => {
        this.$message.success(res.msg);
      })
    },
    // 业务最终处理
    finalDecision(item) {
      this.$refs.finalDecision.form = {
        id: item.id,
        final_solution: item.final_solution,
        problem_category: item.problem_category,
        final_images: [],
        after_sale_sn: '',
        reparation_sn: '',
        is_complaint: item.is_complaint,
      }
      this.$refs.finalDecision.after_sale_sn_list = ''
      this.$refs.finalDecision.reparation_sn_list = ''
      this.$refs.finalDecision.dialogVisible = true
    },
    // 更新业务最终处理
    updateFinalSolution(item) {
      let datas = {
        id: item.id,
        final_solution: item.final_solution,
      }
      this.$api.siteConfiguration.updateFinalSolution(datas).then(res => {
        this.$message.success(res.msg);
      })
    },
  },

}
</script>
<style scoped lang="scss">
.body {
  .search {
    display: flex;
    flex-wrap: wrap;

    .item {
      width: 200px;
      margin-right: 20px;
      margin-bottom: 20px;
    }

    .time {
      margin-right: 20px;
    }
  }

  .tabs {
    position: relative;

    .add {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  .table {
    overflow: auto;

    li {
      margin-right: 10px;

      &:last-child {
        margin-right: 0;
      }
    }

    ol {
      width: 2500px;
    }

    ul {
      width: 2500px;
    }

    .operation {
      position: sticky;
      right: 0;
      left: 0;
      background-color: #EDEFF4;
      box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
    }

    .template {
      width: 100%;
    }


    .flex05 {
      flex: 0.5;
    }

    .flex2 {
      flex: 2;
    }
  }



  .chat_type {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;

    .img {
      font-size: 16px;
      font-weight: bold;
    }

    img {
      width: 40px;
      vertical-align: middle;
    }
  }
}

/deep/.el-textarea__inner {
  height: 120px;
  padding: 5px;
}
</style>
